/* eslint-disable @typescript-eslint/no-unused-vars */
import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import {
  IUseRoutermailPageSearchQuery,
  ComposeModal,
} from 'src/hooks/router/useRouterMail'

export const sendEmailTool = createTool({
  id: 'send-email',
  description:
    'Send an email to a contact. Use this when user wants to send an email or when suggesting to send an email message.',
  inputSchema: z.object({
    objectUniqId: z
      .string()
      .optional()
      .describe(
        'Unique identifier of the related CRM object (contact, deal, etc.)'
      ),
    parentUniqId: z
      .string()
      .optional()
      .describe('Parent object unique identifier if applicable'),
    email: z.string().email().describe('Recipient email address'),
    subject: z.string().describe('Email subject line'),
    messageText: z.string().describe('Email body content'),
    skipConfirmation: z
      .boolean()
      .describe(
        'If true, send the email immediately without asking for user confirmation'
      ),
  }),
  execute: async ({ context }) => {
    const { objectUniqId, parentUniqId, email, subject, messageText } = context
    const skipConfirmation = false

    const querySearch: IUseRoutermailPageSearchQuery & { modal?: string } = {
      modal: ComposeModal,
      mailPage: {
        composeParams: {
          // emailId?: number
          addresseParams: {
            // storageObjects?: IListItem[]
            values: [email],
          },
          // scheme?: string
          subject: subject,
          contentInsert: messageText,
        },
      },
    }
    store.dispatch(
      appActions.navigate({
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `${
        skipConfirmation ? 'Sending' : 'Preparing to send'
      } email to ${email}`,
    }
  },
})
